export default __webpack_public_path__ + "static/media/IMG6981r.53247724.jpg";